import {
  Flex,
  Icon,
  Skeleton,
  Spinner,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';

interface IinfoCard {
  titulo?: string;
  valor?: string;
  desc?: string;
  icon: any;
  cor: any;
  action?: any;
  isLoading?: boolean;
}

const InfoCard: React.FC<IinfoCard> = ({
  titulo,
  valor,
  icon,
  cor,
  action,
  isLoading,
}) => {
  const textColor = useColorModeValue('#3f3f46', '#fff');
  const bg = useColorModeValue('white', 'gray.800');
  const hover = useColorModeValue('gray.100', 'gray.900');

  return (
    <Flex
      borderWidth="1px"
      w="100%"
      rounded="2xl"
      p="6"
      bg={bg}
      _hover={{ bg: action && hover }}
      cursor={action && 'pointer'}
      onClick={action ?? undefined}
      flexDir="column"
    >
      <Flex justify="space-between">
        <Text fontWeight="medium" fontSize="xl">
          {titulo}
        </Text>
        <Icon
          as={icon}
          boxSize="12"
          p="2"
          color={cor}
          rounded="lg"
          //
        />
      </Flex>
      {isLoading ? (
        <Skeleton h="35px" />
      ) : (
        <Text color={textColor} fontWeight="semibold" fontSize="160%" mt="0">
          {valor}
        </Text>
      )}
    </Flex>
  );
};

export default InfoCard;
